export const INTERVIEW_STATUS = {
  UPCOMING: "UPCOMING",
  YET_TO_START: "YET_TO_START",
  ONGOING: "ONGOING",
  FEEDBACK_PENDING: "FEEDBACK_PENDING",
  FINISHED: "FINISHED",
  CANCELLED: "CANCELLED",
  ON_HOLD: "ON_HOLD",
  SELECTED: "SELECTED",
  REJECTED: "REJECTED",
  DECISION_PENDING: "DECISION_PENDING",
};

export const INTERVIEW_ACCESS_STATUS: string[] = [
  INTERVIEW_STATUS.UPCOMING,
  INTERVIEW_STATUS.YET_TO_START,
  INTERVIEW_STATUS.ONGOING,
];
